module.exports = __webpack_public_path__ + "static/media/excel-icon.82ca5842.svg";